import {Injectable} from '@angular/core';
import {LoggedInUser} from '@shared/services/api/logged-in-user';

@Injectable()
export class LoggedInUserState {
  private loggedInUser: LoggedInUser;

  getLoggedInUser(): LoggedInUser {
    return this.loggedInUser;
  }

  setLoggedInUser(loggedInUser: LoggedInUser): void {
    this.loggedInUser = loggedInUser;
  }

  clearLoggedInUser(): void {
    this.setLoggedInUser(null);
  }
}
